import { OptionsObject } from "notistack";
import SnackBarDetailedErrorMessage from "components/core/snackbar/SnackBarDetailedErrorMessage";
import React from "react";

export const DETAILED_ERROR_SNACKBAR_OPTIONS = function (requestId: string): OptionsObject {
  return {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    variant: "error",
    persist: true,
    content: function SnackBarMessage(key: string, message: string) {
      return <SnackBarDetailedErrorMessage id={key} message={message} requestId={requestId} />;
    },
  };
};

export const WARNING_SNACKBAR_OPTIONS: OptionsObject = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  variant: "warning",
  persist: false,
  autoHideDuration: 5000,
};

export const SUCCESS_SNACKBAR_OPTIONS: OptionsObject = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  variant: "success",
  persist: true,
};
